const referredHistoryRouter = [
    {
        path: "list-referred_history",
        name: "list",
        component: () => import("@/views/admin/referred_history"),
        default: true,
        meta: {
            model: "referred_history",
            // requiresAuth: true,
        },
    },
    // {
    //     path: "list-ref_history/add",
    //     name: "add",
    //     component: () => import("@/views/admin/ref_history/function"),
    //     default: true,
    //     meta: {
    //         model: "ref_history",
    //         // requiresAuth: true,
    //     },
    // },
    // {
    //     path: "list-ref_history/edit/:id",
    //     name: "edit",
    //     component: () => import("@/views/admin/ref_history/function"),
    //     default: true,
    //     meta: {
    //         model: "ref_history",
    //         // requiresAuth: true,
    //     },
    // },
];
export default referredHistoryRouter;